import { iconFactory } from '../iconFactory'

export const Walk = iconFactory(
  'Walk',
  ({ fill }) => (
    <path
      d="M9 4.2404C9.73333 4.2404 10.3333 3.6404 10.3333 2.90706C10.3333 2.17373 9.73333 1.57373 9 1.57373C8.26667 1.57373 7.66667 2.17373 7.66667 2.90706C7.66667 3.6404 8.26667 4.2404 9 4.2404ZM6.53333 6.50706L4.66667 15.9071H6.06667L7.26667 10.5737L8.66667 11.9071V15.9071H10V10.9071L8.6 9.57373L9 7.57373C9.86667 8.57373 11.2 9.2404 12.6667 9.2404V7.90706C11.4 7.90706 10.3333 7.2404 9.8 6.30706L9.13333 5.2404C8.76 4.64706 8.01333 4.40706 7.36667 4.6804L4 6.10706V9.2404H5.33333V6.97373L6.53333 6.50706Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
